/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shouldComponentUpdate = _interopRequireDefault(require("../../../../common/shouldComponentUpdate"));
var _default = _shouldComponentUpdate.default;
exports.default = _default;